/* ==========================================================================
   THE PERSONALISATION DRAWER OPENS ON THE FILM

   The drawer's picture is the live engraving preview: it carries the chosen
   case and the shopper's own initials, and it has to stay. So the film sits
   OVER it rather than replacing it, and steps aside the moment there is
   something of theirs to look at - the first keystroke in the initials field,
   or a change of colour. Before that there is nothing personal to preview and
   a still of a plain case argues nothing; twenty-four seconds of a monogram
   being stamped argues the whole product.

   Pressing it opens the same modal the product page uses, with sound and the
   call to action - this is only another trigger for it, not a second player.

   The drawer is built from a <template> at run time, so nothing here can be
   bound up front; everything is found when the drawer actually opens.
   ========================================================================== */
(function () {
  "use strict";

  var PREVIEW_MAX = 5;      /* seconds - caps what is fetched, as on the PDP */
  var wired = false;
  var layer = null;
  var vid = null;
  var started = false;

  function metered() {
    var c = navigator.connection || {};
    return c.saveData === true ||
      (typeof c.effectiveType === "string" && /(^|-)2g$|^3g$/.test(c.effectiveType));
  }

  function drawer() { return document.querySelector("[data-personalize-drawer]"); }
  function input() { return document.querySelector("[data-personalize-input]"); }

  function hide() {
    if (!layer) return;
    layer.hidden = true;
    if (vid) { try { vid.pause(); } catch (e) {} }
  }

  function show() {
    if (!layer) return;
    /* nothing to open means nothing to advertise */
    if (!document.querySelector("[data-gc-pvid-modal]")) { hide(); return; }
    layer.hidden = false;
    play();
  }

  function play() {
    if (!vid || metered()) return;
    if (!started) {
      var api = window.gcPersonalizeVideo;
      var src = (api && api.sd) || vid.getAttribute("data-src");
      if (!src) return;
      started = true;
      /* the frame it paints when playback is refused - without it, black */
      if (api && api.poster) vid.setAttribute("poster", api.poster);
      vid.src = src;
      /* Rewound by hand instead of using the loop attribute, so only the first
         few seconds are ever fetched rather than the whole rendition. */
      vid.addEventListener("timeupdate", function () {
        if (vid.currentTime < PREVIEW_MAX) return;
        try { vid.currentTime = 0; } catch (e) {}
      });
      vid.addEventListener("playing", function () {
        layer.classList.add("is-playing");
      }, { once: true });
    }
    var p = vid.play();
    if (p && p.catch) p.catch(function () {
      /* blocked: the poster frame stands, and the first touch is the gesture
         the browser was waiting for */
      document.addEventListener("pointerdown", function once() {
        document.removeEventListener("pointerdown", once, true);
        if (layer && !layer.hidden && vid) { var q = vid.play(); if (q && q.catch) q.catch(function () {}); }
      }, true);
    });
  }

  /* the first sign that the shopper has something of their own to look at */
  function engaged() { hide(); }

  function wire() {
    var d = drawer();
    if (!d) return;
    layer = d.querySelector("[data-pzd-vid]");
    if (!layer) return;
    vid = layer.querySelector("[data-pzd-vid-el]");
    if (wired) return;
    wired = true;

    var i = input();
    if (i) {
      i.addEventListener("input", engaged);
      i.addEventListener("focus", engaged);
    }
    /* any colour or variant control inside the drawer counts as engagement */
    d.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest("[data-pzd-vid]")) return;              /* the film itself */
      if (t.closest("[data-variant-collapse], [data-color-swatch], .personalize-drawer__variant-collapse, .personalize-drawer__swatch")) engaged();
    }, true);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { if (vid) { try { vid.pause(); } catch (e) {} } }
      else if (layer && !layer.hidden) play();
    });
  }

  function onOpen() {
    wire();
    if (!layer) return;
    var i = input();
    /* Someone who already has initials in the field has engaged before; they
       want to see their engraving, not the film. */
    if (i && i.value && i.value.trim()) hide(); else show();
  }

  /* the drawer signals open with a class on <body> */
  var open = false;
  function check() {
    var now = document.body.classList.contains("personalize-drawer-open");
    if (now === open) return;
    open = now;
    if (now) onOpen(); else hide();
  }

  if (typeof MutationObserver === "function") {
    new MutationObserver(check).observe(document.body, {
      attributes: true, attributeFilter: ["class"]
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", check);
  } else {
    check();
  }
})();
